module.exports = require('classnames');



/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-util/lib/classSet.js
 ** module id = 1102
 ** module chunks = 0
 **/